/* less/lib/less/tree/detached-ruleset */ function _(require, module, exports) {
    var Node = require(232) /* ./node */, contexts = require(169) /* ../contexts */, utils = require(245) /* ../utils */;
    var DetachedRuleset = function (ruleset, frames) {
        this.ruleset = ruleset;
        this.frames = frames;
        this.setParent(this.ruleset, this);
    };
    DetachedRuleset.prototype = new Node();
    DetachedRuleset.prototype.type = 'DetachedRuleset';
    DetachedRuleset.prototype.evalFirst = true;
    DetachedRuleset.prototype.accept = function (visitor) {
        this.ruleset = visitor.visit(this.ruleset);
    };
    DetachedRuleset.prototype.eval = function (context) {
        var frames = this.frames || utils.copyArray(context.frames);
        return new DetachedRuleset(this.ruleset, frames);
    };
    DetachedRuleset.prototype.callEval = function (context) {
        return this.ruleset.eval(this.frames ? new contexts.Eval(context, this.frames.concat(context.frames)) : context);
    };
    module.exports = DetachedRuleset;
}
